var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssets({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-160v-90h86v-490q0-24.75 17.625-42.375T226-800h620v60H226v490h234v90H80Zm479 0q-16.575 0-27.787-13.5Q520-187 520-204v-437q0-16.575 11.213-27.787Q542.425-680 559-680h271.751Q850-680 865-669.5q15 10.5 15 28.5v437.273q0 18.584-14.5 31.155Q851-160 831-160H559Zm21-90h240v-370H580v370Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.2c54ab34add7d70e26766781bdd0a1f8.svg";
export { ForwardRef as ReactComponent };